import { Button, Input } from "@material-ui/core";

interface OptionalNumericInputProps {
    value: number | null;
    setValue: (value: number | null) => void;
    initialValue: number;
    setButtonText: string;
    resetButtonText: string;
    labelText: string;
}

const OptionalNumericInput = ({ value, setValue, initialValue, setButtonText, resetButtonText, labelText }: OptionalNumericInputProps) => {
    if (value === null) {
        return <Button size="small" variant="contained" onClick={() => setValue(initialValue)}>{setButtonText}</Button>;
    }

    return <>
        <Button size="small" variant="contained" onClick={() => setValue(null)}>{resetButtonText}</Button>
        <label>{labelText} <Input type="number" value={value} onChange={e => setValue(+e.target.value)} /></label>
    </>;
}

export default OptionalNumericInput;